export default __webpack_public_path__ + "static/media/footer.ae2ee9a0.png";